export default ({
  fetching: {
    createRequestModel: false,
    updateRequestModel: false,
    listRequestModel: false,
    getRequestModel: false
  },
  api: {
    requestList: [],
    requestModel: {
      requestModelId: null,
      name: '',
      content: ''
    }
  },
  forms: {
    modal: {
      name: {
        value: '',
        error: false
      },
      description: {
        value: '',
        error: false
      }
    }
  }
});